<template>
  <router-link :to="link" :class="['btn', `btn--${type}`]">
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    link: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  display: inline-block;
  padding: 12px 14px;
  min-width: 215px;
  text-decoration: none;
  font-size: rem(16);
  font-weight: 700;
  border: 2px solid $--color-landing-primary;
  transition: all 0.1s ease-in-out;

  &:hover {
    border-color: $--color-purple-hover;
  }

  &:active {
    border-color: $--color-purple-active;
  }
}

.btn--primary {
  background-color: $--color-landing-primary;
  color: $--color-white;

  &:hover {
    color: $--color-white;
    background-color: $--color-purple-hover;
  }

  &:active {
    color: $--color-white;
    background-color: $--color-purple-active;
  }
}

.btn--secondary {
  background-color: $--color-white;
  color: $--color-landing-primary;
  &:hover {
    color: $--color-purple-hover;
  }

  &:active {
    color: $--color-purple-active;
  }
}

.btn-group {
  .btn {
    margin: 8px 15px;
  }
}
</style>
